import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
// Kuitwa kwa PageHero Component
import PageHero from "../ones/PageHero";

// Kuimport picha za kurasa na background ya Hero
import loansHeroBg from '../assets/banner9.png';
import devLoanImg from '../assets/image21.jpeg';
import emergencyLoanImg from '../assets/image22.jpeg';

import { FaRegDotCircle, FaCalculator, FaShieldAlt, FaClock, FaPercent, FaHandHoldingWater } from "react-icons/fa";
import { IoMdCheckmarkCircle } from "react-icons/io";

export default function LoansDetailed(props) {
    const appContext = useContext(AppContext);
    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        // Initializations kama zipo (e.g. fetching interest rates dynamically)
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    if (ready) {
        return (
            <>
            <div className="ycsc-loans-detailed-page animate__animated animate__fadeIn">
                
                {/* 1. HERO BANNER */}
                <PageHero 
                    bgImage={loansHeroBg}
                    kicker="Mikopo Yetu"
                    heading="Fungua Milango ya Mafanikio"
                    paragraph="Tunatoa suluhisho la mikopo ya kiwango cha juu yenye riba nafuu na masharti rafiki yaliyoundwa kukusaidia kukua kibiashara na kukabiliana na dharura kwa amani."
                />

                {/* 2. CORE FEATURES / TRUST ACCENTS */}
                <section className="py-4 bg-white border-bottom">
                    <div className="container">
                        <div className="row g-3 text-center">
                            <div className="col-6 col-md-3">
                                <div className="d-flex align-items-center justify-content-center gap-2 text-primary">
                                    <FaPercent className="fs-5 text-warning" />
                                    <span className="fw-bold text-dark small-md">Riba Nafuu Mno</span>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="d-flex align-items-center justify-content-center gap-2 text-primary">
                                    <FaClock className="fs-5 text-warning" />
                                    <span className="fw-bold text-dark small-md">Ushughulikiaji wa Haraka</span>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="d-flex align-items-center justify-content-center gap-2 text-primary">
                                    <FaShieldAlt className="fs-5 text-warning" />
                                    <span className="fw-bold text-dark small-md">Masharti ya Uwazi</span>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="d-flex align-items-center justify-content-center gap-2 text-primary">
                                    <FaCalculator className="fs-5 text-warning" />
                                    <span className="fw-bold text-dark small-md">Urejesho wa Kubadilika</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 3. DETAILED LOAN TYPES */}
                <section className="py-5 bg-light-surface">
                    <div className="container">
                        
                        {/* TYPE 1: MIKOPO YA MAENDELEO */}
                        <div className="row align-items-center g-5 mb-5 premium-loan-row">
                            <div className="col-12 col-lg-6">
                                <div className="loan-detailed-img-wrapper shadow">
                                    <img src={devLoanImg} alt="Mikopo ya Maendeleo YCSC" className="img-fluid rounded-4" />
                                    <div className="loan-type-tag">Maendeleo & Biashara</div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="loan-detailed-info-content">
                                    <div className="accent-bar mb-3"></div>
                                    <h2 className="loan-title fw-extrabold mb-3">1. Mikopo ya Maendeleo na Biashara</h2>
                                    <p className="lead text-muted mb-4">
                                        Huu ni mkopo wa kimkakati ulioundwa kwa ajili ya wanachama wanaotaka kutekeleza miradi mikubwa, kupanua biashara, kununua vifaa, ujenzi au kuwekeza kwenye kilimo chenye tija ya muda mrefu.
                                    </p>
                                    
                                    <h5 className="fw-bold text-primary mb-3">Sifa na Manufaa Kuu:</h5>
                                    <ul className="list-unstyled premium-benefits-list mb-4">
                                        <li className="d-flex align-items-start mb-2">
                                            <IoMdCheckmarkCircle className="text-success fs-5 me-2 mt-1 flex-shrink-0" />
                                            <span><strong>Kiwango Kikubwa cha Mtaji:</strong> Uwezo wa kukopa hadi mara 3 ya akiba yako yote uliyoweka SACCOS.</span>
                                        </li>
                                        <li className="d-flex align-items-start mb-2">
                                            <IoMdCheckmarkCircle className="text-success fs-5 me-2 mt-1 flex-shrink-0" />
                                            <span><strong>Muda Mrefu wa Marejesho: </strong>Kipindi cha marejesho kimepangwa kwa urahisi ili kuipa biashara yako nafasi ya kuzalisha faida kwanza. Utaweza kulipa taratibu kwa hadi miezi 24.</span>
                                        </li>
                                        <li className="d-flex align-items-start mb-2">
                                            <IoMdCheckmarkCircle className="text-success fs-5 me-2 mt-1 flex-shrink-0" />
                                            <span><strong>Ushauri wa Kibiashara:</strong> Kupata mwongozo na mafunzo ya usimamizi wa fedha kutoka kwa wataalamu wetu kabla na baada ya kupewa mkopo.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* TYPE 2: MIKOPO YA DHARURA */}
                        <div className="row align-items-center g-5 pt-4 premium-loan-row flex-lg-row-reverse">
                            <div className="col-12 col-lg-6">
                                <div className="loan-detailed-img-wrapper shadow">
                                    <img src={emergencyLoanImg} alt="Mikopo ya Dharura YCSC" className="img-fluid rounded-4" />
                                    <div className="loan-type-tag bg-warning-accent">Dharura & Jamii</div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="loan-detailed-info-content">
                                    <div className="accent-bar bg-warning mb-3"></div>
                                    <h2 className="loan-title fw-extrabold mb-3">2. Mikopo ya Dharura na Jamii</h2>
                                    <p className="lead text-muted mb-4">
                                        Maisha yana dharura zisizotabirika. Mkopo huu unapatikana kwa haraka wa kipekee ndani ya masaa machache ili kukabiliana na changamoto za ghafla za kifamilia au kijamii bila kuchelewa.
                                    </p>
                                    
                                    <h5 className="fw-bold text-primary mb-3">Sifa na Manufaa Kuu:</h5>
                                    <ul className="list-unstyled premium-benefits-list mb-4">
                                        <li className="d-flex align-items-start mb-2">
                                            <IoMdCheckmarkCircle className="text-success fs-5 me-2 mt-1 flex-shrink-0" />
                                            <span><strong>Utoaji wa Haraka wa Kidijitali:</strong> Maombi yanachakatwa kwa kipaumbele cha juu ili kuhakikisha unapata fedha ndani ya muda mfupi zaidi.</span>
                                        </li>
                                        <li className="d-flex align-items-start mb-2">
                                            <IoMdCheckmarkCircle className="text-success fs-5 me-2 mt-1 flex-shrink-0" />
                                            <span><strong>Inashughulikia Mahitaji Muhimu:</strong> Maalum kwa ajili ya kulipia ada za shule za dharura, matibabu, au majanga yoyote yasiyotarajiwa.</span>
                                        </li>
                                        <li className="d-flex align-items-start mb-2">
                                            <IoMdCheckmarkCircle className="text-success fs-5 me-2 mt-1 flex-shrink-0" />
                                            <span><strong>Urahisi wa Masharti:</strong> Uhakiki wa haraka unaozingatia historia yako safi ya uaminifu na akiba ndani ya YCSC SACCOS. Na utaweza kulipa taratibu kwa hadi miezi sita</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                {/* 4. GENERAL ELIGIBILITY & HOW TO APPLY */}
                <section className="py-5 bg-white">
                    <div className="container">
                        <div className="row justify-content-center text-center mb-5">
                            <div className="col-lg-7">
                                <span className="premium-accent-kicker">Vigezo & Hatua</span>
                                <h2 className="premium-section-title mt-2">Je, Unahitaji Mkopo?</h2>
                                <p className="text-muted">Utaratibu wetu ni rahisi, wazi na hauna vikwazo vyenye urasimu wa kizamani.</p>
                                <div className="section-title-separator mx-auto"></div>
                            </div>
                        </div>

                        <div className="row g-4">
                            {/* ELIGIBILITY CRITERIA CARD */}
                            <div className="col-12 col-md-6">
                                <div className="eligibility-box p-4 p-md-5 rounded-4 h-100 shadow-sm border">
                                    <h4 className="fw-bold text-dark border-bottom pb-3 mb-3 d-flex align-items-center gap-2">
                                        <FaRegDotCircle className="text-primary animate__animated animate__pulse animate__infinite" /> 
                                        Sifa za Mwombaji
                                    </h4>
                                    <ul className="list-unstyled custom-check-list">
                                        <li className="mb-3 d-flex align-items-start gap-2">
                                            <span className="bullet-num">1</span>
                                            <span>Kuwa mwanachama hai na aliyesajiliwa kikamilifu ndani ya YCSC SACCOS.</span>
                                        </li>
                                        <li className="mb-3 d-flex align-items-start gap-2">
                                            <span className="bullet-num">2</span>
                                            <span>Kushiriki kikamilifu katika kujiwekea akiba ya lazima ya kila mwezi bila kukosa.</span>
                                        </li>
                                        <li className="mb-3 d-flex align-items-start gap-2">
                                            <span className="bullet-num">3</span>
                                            <span>Kuwa na kiwango cha akiba cha kutosha <strong>walau mara 3 ya </strong>kiwango cha mkopo unaomba.</span>
                                        </li>
                                        <li className="mb-3 d-flex align-items-start gap-2">
                                            <span className="bullet-num">4</span>
                                            <span>Kuwa na wadhamini waaminifu walau wawili ambao pia ni wanachama hai wa chama chetu.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            {/* HOW TO APPLY STEPS CARD */}
                            <div className="col-12 col-md-6">
                                <div className="eligibility-box p-4 p-md-5 rounded-4 h-100 shadow-sm border bg-light-surface-tint">
                                    <h4 className="fw-bold text-dark border-bottom pb-3 mb-3 d-flex align-items-center gap-2">
                                        <FaHandHoldingWater className="text-warning" /> 
                                        Hatua za Kuomba Mkopo
                                    </h4>
                                    <div className="timeline-steps">
                                        <div className="step-item d-flex gap-3 mb-4">
                                            <div className="step-badge">A</div>
                                            <div>
                                                <h6 className="fw-bold text-dark mb-1">Jaza Fomu ya Maombi</h6>
                                                <p className="small text-muted mb-0">Pakua fomu mtandaoni au jaza kupitia mfumo wetu wa kidijitali wa mwanachama.</p>
                                            </div>
                                        </div>
                                        <div className="step-item d-flex gap-3 mb-4">
                                            <div className="step-badge">B</div>
                                            <div>
                                                <h6 className="fw-bold text-dark mb-1">Uwasilishaji na Uhakiki</h6>
                                                <p className="small text-muted mb-0">Kamati ya mikopo itapitia maombi yako na kufanya tathmini ya haraka ya uwezo wa urejesho.</p>
                                            </div>
                                        </div>
                                        <div className="step-item d-flex gap-3">
                                            <div className="step-badge bg-success-accent">C</div>
                                            <div>
                                                <h6 className="fw-bold text-dark mb-1">Idhini na Kupokea Fedha</h6>
                                                <p className="small text-muted mb-0">Baada ya kuidhinishwa, fedha zitatumwa moja kwa moja kwenye akaunti yako ya benki au simu kwa usalama.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

            </div>
            <Footer />
            </>
        );
    } else {
        return (
            <div className="container mSupportLoading py-5 text-center">
                {getInlineLoader()}
            </div>
        );
    }
}